import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export interface FormValues {
  endpoint: string;
  userName: string;
  password: string;
  tlsCertificate: string;
}

export const defaultValues: FormValues = {
  endpoint: '',
  userName: '',
  password: '',
  tlsCertificate: ''
};

function setSchema() {
  return yup.object({
    endpoint: yup.string().concat(
      yup
        .string()
        .required('URL is required.')
        .matches(
          /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\S]*)?$/i,
          'Please enter a valid URL (e.g https://eteamproject.internal.ericsson.com).'
        )
    ),
    userName: yup.string().concat(yup.string().required('User Name is required.').min(1, 'User Name cannon be empty.')),
    password: yup.string().concat(yup.string().required('Password is required.').min(1, 'Password cannon be empty')),
    tlsCertificate: yup
      .string()
      .required('TLS certificate is required')
      .matches(
        /-----BEGIN CERTIFICATE-----[\s\S]*-----END CERTIFICATE-----/,
        'Certificate must contain BEGIN CERTIFICATE and END CERTIFICATE blocks'
      )
  });
}

export function useTestManagementForm(initialValues?: FormValues) {
  const schema = setSchema();
  return useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
    defaultValues: { ...defaultValues, ...initialValues }
  });
}
